module.exports = __webpack_public_path__ + "static/media/blueVert.028da635.png";